import type { ListBuilderList } from '../../../types';
import { createCompletedTaskColumns } from '../columns';

/**
 * Completed Tasks list configuration
 * Shows completed tasks from the last 7 days
 * Note: Uses different columns (no complete-column)
 */
export const completedTasksList: ListBuilderList = {
	id: 'completed-tasks',
	cacheTTL: 300000,
	name: 'Completed',
	type: 'default',
	active: true,
	sortOrder: 6,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskCompletedDateRange',
	],
	columns: createCompletedTaskColumns(),
	defaultSortId: 'column-completed-date-column-desc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskStatus: {
			defaultValue: [{ id: 'completed', label: 'Completed' }],
		},
		taskCompletedDateRange: {
			defaultValue: [
				{
					id: 'last-7-days',
					label: 'Last 7 Days',
					data: {
						startDate: '{{DATE:-7d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
